import { getUser } from 'containers/App/selectors';
import { useSelector } from 'react-redux';

export const useAuth = () => {
  const user = useSelector(getUser());

  return { user };
};
